import { Theme } from "@mui/material/styles"
import { CompilationsListItemTheme } from "core/themes/src/definitions/components.types"

export const createCompilationsListItemTheme = (theme: Theme): CompilationsListItemTheme => ({
    styleOverrides: {
        title: {
            textTransform: "none",
        },
    },
})
